import React, { useEffect } from 'react';

const Header = () => {
  // Function to handle language change
  const handleLanguageChange = () => {
    // This ensures the page content is properly updated after translation
    setTimeout(() => {
      window.location.reload();
    }, 500);
  };

  useEffect(() => {
    // Add event listener for language change
    const interval = setInterval(() => {
      const googleTranslateFrame = document.querySelector('.goog-te-menu-frame');
      if (googleTranslateFrame) {
        const select = googleTranslateFrame.contentDocument?.querySelector('.goog-te-menu1-select');
        if (select) {
          select.addEventListener('change', handleLanguageChange);
        }
      }
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  return (
    <>
      <nav className="navbar navbar-expand-lg bg-white navbar-light shadow sticky-top p-0">
        <a href="/" className="navbar-brand ml-lg-3">
          &nbsp;&nbsp;&nbsp;
          <img src="img/logo.jpg" alt="Edukate" style={{ height: "70px" }} />
        </a>
        <button
          type="button"
          className="navbar-toggler me-4"
          data-bs-toggle="collapse"
          data-bs-target="#navbarCollapse"
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className="collapse navbar-collapse" id="navbarCollapse">
          <div className="navbar-nav ms-auto p-4 p-lg-0">
            <a href="/" className="nav-item nav-link">
              Home
            </a>
            <a href="/about" className="nav-item nav-link">
              About
            </a>
            <div className="nav-item dropdown">
              <a
                href="#"
                className="nav-link dropdown-toggle"
                data-bs-toggle="dropdown"
              >
                Courses
              </a>
              <div className="dropdown-menu fade-down m-0">
                <a href="/Team" className="dropdown-item">
                  Our Team
                </a>
                <a href="/Courses" className="dropdown-item">
                  Courses
                </a>
                <a href="/StudyinEnglish" className="dropdown-item">
                  Study in India
                </a>
                <a href="/StudyEnglishfor" className="dropdown-item">
                  Study English For Beginners
                </a>
                <a href="/Howcanispeak" className="dropdown-item">
                  How can i Speak
                </a>
              </div>
            </div>
            <a href="/Whymcm" className="nav-item nav-link">
              Why M.C.M ?
            </a>
            <a href="/Infrastructure" className="nav-item nav-link">
              Infrastructure
            </a>
            <div className="nav-item dropdown">
              <a
                href="#"
                className="nav-link dropdown-toggle"
                data-bs-toggle="dropdown"
              >
                Mysore
              </a>
              <div className="dropdown-menu fade-down m-0">
                <a href="/Whymysore" className="dropdown-item">
                  Why Mysore
                </a>
                <a href="/Mysoretourisim" className="dropdown-item">
                  Mysore Tourism
                </a>
              </div>
            </div>
            <a href="/Administration" className="nav-item nav-link">
              Administration
            </a>
            <a href="/InternationalStudents" className="nav-item nav-link">
              International Students
            </a>
            <a href="/Contact" className="nav-item nav-link">
              Contact
            </a>
          </div>
          
          {/* Optional: You can add the translator here instead of in App.js */}
          {/* Uncomment if you want the translator in the header */}
          {/* 
          <div className="ms-3">
            <div id="google_translate_element_header"></div>
          </div>
          */}
          
          {/* <a
            href="#"
            className="btn btn-primary py-4 px-lg-5 d-none d-lg-block"
          >
            Join Now<i className="fa fa-arrow-right ms-3"></i>
          </a> */}
        </div>
      </nav>
    </>
  );
};

export default Header;